import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=8b0c5acc&scoped=true"
import script from "./BaseBox.vue?vue&type=script&lang=ts"
export * from "./BaseBox.vue?vue&type=script&lang=ts"
import style0 from "./BaseBox.vue?vue&type=style&index=0&id=8b0c5acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0c5acc",
  null
  
)

export default component.exports